import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	issuesPerDeployment: {
		id: 'software-deployment-frequency-report.batch-size-chart.chart.tooltip.issues-per-deployment',
		defaultMessage: '{numIssues} {numIssues, plural, one {issue} other {issues}} per deployment',
		description: 'Display median issues shipped to production per deployment',
	},
});
